import { STUDENT_ROUTE } from 'app/routing-constants/student-routing.constant';

export const NOTIFICATIONS_ROUTE = {
  name: 'notifications',
  route(classId: string): string[] {
    return [...STUDENT_ROUTE.LOGGED.route(classId), this.name];
  },

  DEFAULT: ''
};
